import { useMutation, useQueryClient } from "@tanstack/react-query";
import { axios } from "./axios";
import { useAuth } from "../context/AuthContext";
import { env } from "../utils/env";
import { CheckAddress } from "../types/CheckAddress";

export type ProfileParams = {
  profileId: number;
  _type?: "entity" | "individual";
  first_name?: string;
  middle_name?: string | null;
  last_name?: string;
  gender?: "male" | "female" | "other";
  date_of_birth?: string;
  name?: string;
  entity_type?: number;
  registration_number?: string;
  date_of_incorporation?: string;
  country?: number;
  email?: string;
  owner?: number | null;
  reviewer?: number | null;
  address?: CheckAddress
};

export const useEditProfileAddress = () => {
  const { authHeader } = useAuth();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ profileId, ...rest }: ProfileParams) => {
      const payload = Object.fromEntries(
        Object.entries(rest).filter(
          ([key, value]) => value !== undefined && key !== "created_by"
        )
      );

      return axios.put(
        `${env.verifyServiceUrl}individual/profile/${profileId}/`,
        payload,
        {
          headers: {
            Authorization: authHeader,
          },
        }
      );
    },

    onSuccess: async (_data, vars) => {
      setTimeout(() => {
        queryClient.invalidateQueries({
          queryKey: ["profile", vars.profileId],
        });
      }, 0);
    },
  });
};
